import { Shape } from "./shape";

export class teamComplicatedSubsystem extends Shape{
    override color: string = "#ffc08b";
    override strokeColor: string = "#e68922";
    override strokeDashArray: [number, number] = [0, 0];
    override points: string ="6.25,0 18.75,0 25,6.25 25,18.75 18.75,25 6.25,25 0,18.75 0,6.25" 
    

    constructor() {
        super();
    }

    
}